export const getNewGruserPortFlagName = section => {
  let newGruserPortFlagName;
  switch (section) {
    case 'home':
      newGruserPortFlagName = 'gruser_home';
      break;
    case 'about':
      newGruserPortFlagName = 'gruser_about';
      break;
    case 'gallery':
    case 'favourites':
    case 'private_collections':
      newGruserPortFlagName = 'gruser_gallections';
      break;
    case 'shop':
      newGruserPortFlagName = 'gruser_shop';
      break;
    case 'posts':
      newGruserPortFlagName = 'gruser_posts';
      break;
    case 'subscriptions':
      newGruserPortFlagName = 'gruser_subscriptions';
      break;
    default:
      newGruserPortFlagName = 'deviation_gruser_port';
  }
  return newGruserPortFlagName;
};
